import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { getFileIcon, getFileSize } from '../FilePreview'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { downloadMessageFile } from '../../../utils/api/chatMessage'
import { ColorsPalette } from '../../../config/colors'

const OPACITY = 0.3

const ChatMessageFile = ({ file, received }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [isHovered, setIsHovered] = useState(false)

  const fileIcon = getFileIcon(file)

  const handleDownload = () => {
    downloadMessageFile(user, file)
  }

  const iconStyle = received ? { opacity: isHovered ? OPACITY : 1, backgroundColor: ColorsPalette.LIGHT_SLATE_GREY } : { opacity: isHovered ? OPACITY : 1 }

  return (
    <div className={'flex-row message-file ai-ctr mt-8 h-55p' + (received ? ' received' : ' sent')} onClick={handleDownload} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className='icon-container flex-column h-100 jc-ctr w-50p pd-16' style={iconStyle}>
        <FontAwesomeIcon icon={fileIcon} size='xl' />
      </div>
      <div className='file-data-container flex-column pd-8 h-100' style={{ width: 'calc(100% - 51px)', opacity: isHovered ? OPACITY : 1 }}>
        <div className='text-ellipsis'>
          <b>{file.originalName}</b>
        </div>
        <div className='file-size'> {getFileSize(file)} </div>
      </div>
      {isHovered && (
        <div className='flex-row download-overlay ai-ctr jc-ctr h-100 w-100'>
          <FontAwesomeIcon icon={faDownload} size='lg' />
          <b> {t('common.download')}</b>
        </div>
      )}
    </div>
  )
}

export default ChatMessageFile
